import defaultFetch from 'isomorphic-unfetch';

interface CeLoginApiResponse {
  isValidCeUser: boolean;
}

export interface CeLoginApiClient {
  login: (user: string, pass: string) => Promise<CeLoginApiResponse>;
}

interface Dependencies {
  env: {
    NEXT_PUBLIC_API_BASE_URL: string;
  };
  fetch: typeof defaultFetch;
}

export const createCeLoginApiClient = (dependencies: Partial<Dependencies> = {}): CeLoginApiClient => {
  const {
    fetch = defaultFetch,
    env = {
      NEXT_PUBLIC_API_BASE_URL: process.env.NEXT_PUBLIC_API_BASE_URL,
    },
  } = dependencies;

  async function login(user: string, pass: string): Promise<CeLoginApiResponse> {
    const response = await fetch(`${env.NEXT_PUBLIC_API_BASE_URL}/CeLoginApi/CeLogin`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ userParam: user, passParam: pass }),
      credentials: 'include',
    });

    if (!response.ok) {
      return { isValidCeUser: false };
    }

    const data: CeLoginApiResponse = await response.json();

    return { isValidCeUser: data.isValidCeUser ?? false };
  }

  return {
    login,
  };
};
